export function showDepartmentNavItem(name: string) {
  document
    .querySelector(`[data-nav-department='${name}']`)
    ?.classList.remove("hidden");
}

export function hideDepartmentNavItem(name: string) {
  document
    .querySelector(`[data-nav-department='${name}']`)
    ?.classList.add("hidden");
}
